
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/5-fun-things-to-do-at-home",
      function () {
        return require("private-next-pages/blog/5-fun-things-to-do-at-home.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/5-fun-things-to-do-at-home"])
      });
    }
  